import { useTheme } from 'styled-components';
import { useMediaQuery } from 'react-responsive';

export const useIsTablet = () => {
    const theme = useTheme();
    return useMediaQuery({
        query: theme?.sizes.mediaQueries.tabletMax,
    });
};
